import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ElectricChargerFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M3.9 19.84V4.08H14.26V7.88C14.54 7.48 14.96 7.26 15.52 7.26C16.34 7.26 17.18 7.94 17.18 9.06V16.82C17.18 17.22 17.52 17.56 17.92 17.56C18.32 17.56 18.66 17.22 18.66 16.82V8.4C18.66 7.24 18.2 6.46 17.14 5.78L16.28 5.22L17.1 4.04L18.06 4.66C19.3 5.46 20.1 6.48 20.1 8.02V16.82C20.1 17.94 19.22 19 17.92 19C16.62 19 15.74 17.94 15.74 16.82V9.26C15.74 8.84 15.4 8.52 15 8.52C14.6 8.52 14.26 8.84 14.26 9.26V19.84H3.9ZM12.06 11.16H9.44L10.64 8.68H9.54L6.1 12.64H8.72L7.52 15.12H8.62L12.06 11.16Z" />
    </SvgIcon>
  );
});
